type OutlineStrokeArgs = {
  isHighlighted: boolean;
  hasSectionColor: boolean;
  sectionBorder?: string;
  overlay: boolean;
};

export function getGridSpaceOutlineStroke({
  isHighlighted,
  hasSectionColor,
  sectionBorder,
  overlay
}: OutlineStrokeArgs): string {
  if (isHighlighted) {
    return '#3b82f6';
  }
  if (hasSectionColor && sectionBorder) {
    return sectionBorder;
  }
  if (overlay) {
    return '#d1d5db';
  }
  return '#9ca3af';
}

export function getGridSpaceOutlineStrokeWidth(isHighlighted: boolean): number {
  return isHighlighted ? 4 : 2;
}
